<app-modal [open]="active" [name]="'accepted-offered-proposal'" (close)="closeDialog()">
  <div modal-header>{{ multiple ? "Offers Accepted!" : "Offer Accepted!" }}</div>
  <div modal-body>
    {{ multiple ? "All offers have been" : "The offer was" }} accepted and can
    be viewed from the <strong>Pending</strong> tab.
  </div>
  <button
    modal-footer
    type="button"
    class="btn btn--primary"
    routerLink="/proposals"
    routerLinkActive="router-link-active"
    data-testid="accepted-offered-proposal-view-pending"
    (click)="closeDialog()"
  >
    View Pending
  </button>
  <button
    modal-footer
    type="button"
    class="btn btn--secondary"
    data-testid="accepted-offered-proposal-close"
    (click)="closeDialog()"
  >
    Back
  </button>
</app-modal>
